import type {Config} from "@/src/api/client";
import {client} from "@/src/api/client.gen";
import {handleRequest, handleResponse, handleError} from "@/src/config/api/interceptor/authorize.ts";

export const createClientConfig = (config: Config) => {
  client.setConfig({
    baseURL: "",
    headers: {
      "Content-Type": "application/json",
    },
    throwOnError: true,
  });
  client.instance.interceptors.request.use(handleRequest);
  client.instance.interceptors.response.use(handleResponse, handleError);
  return config;
};